import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Input, Checkbox, Button } from 'antd'
import classnames from 'classnames'
import _ from 'lodash'
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc'

import reactMixin from 'react-mixin'
import TipMixin from '@helpers/TipMixin'
import Modal from '@components/common/Modal'
import Select from '@components/common/Select'
import NumberInput from '@components/NumberInput'
import ColorPicker from '@components/ColorPicker'
import { notifyAlert } from '@components/notification'
import Popover from '@components/common/Popover'

import { RESERVE_OPTION_MAPS } from '../../../../utils/incOptions'

import {
  ITEM_CLASS,
  shouldCancelStart,
  LineStyles,
  defaultSettings,
  DEFAULT_LINE,
  CalcList,
  getCalcName
} from './helper'

import './icon/iconfont.css'
import cssStyles from './markline-config.module.less'

class MarklineConfig extends React.Component {
  static propTypes = {
    chart: PropTypes.object,
    data: PropTypes.array,
    onChange: PropTypes.func,
    fetchFieldOptions: PropTypes.func,
    axis: PropTypes.string, //y左轴, z右轴
    dynamic: PropTypes.bool, // 是否支持计算值
    dataFeildList: PropTypes.object //数据集字段列表
  }
  constructor(props) {
    super(props)
    this.enableHidden = false
    this.state = {
      data: _.cloneDeep(props.data),
      fieldsOption: {},
      dragToIndex: -1,  //拖动后的index
      currentIndex: -1, //拖动前index
      dragItem: null,
      mode_list: props.dynamic ? ['固定值', '计算值', '高级计算'] : ['固定值'],
      calc_num: [],
      foucsSelectNums: []
    }
  }
  componentWillMount() {
    document.addEventListener('wheel', this.closeDropdown)
    document.addEventListener('click', this.clickBody)
  }
  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.data, this.props.data)) {
      this.setState({
        data: _.cloneDeep(nextProps.data)
      })
    }
  }
  componentWillUnmount() {
    document.removeEventListener('wheel', this.closeDropdown)
    document.removeEventListener('click', this.clickBody)
  }
  render() {
    const { visible, data } = this.state
    const conditions = data.data
    return (
      <div className="diagram-design-config-content">
        <div className="layout-config-column-custom markline-config">
          <span className="layout-config-column-title markline-config-title" style={{ fontSize: '14px', height: '30px' }}>
            辅助线
          </span>
          <div className='markline-config-component special'>
            {
              conditions.length > 0 && <div className="delete-handler"><button type='button' onClick={this.removeConfigs} >
                <i className='iconfont icon-recycle-bin' />
              </button></div>
            }
            <div className="handler">
              <button type='button' onClick={this.showDialog}>
                <i className='iconfont-date-filter icon-date-filter-edit' />
              </button>
            </div>
            <Modal
              maskClosable={false}
              wrapClassName='markline-config-dialog special'
              maskStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.45)'
              }}
              width={668}
              title="辅助线配置"
              visible={visible}
              onCancel={this.hideDialog}
              footer={[
                <Checkbox key="checkbox" checked={this.state.data.show} className="show-markline-name" onChange={e => this.toggleShowName(e)}>显示辅助线名称</Checkbox>,
                <Button className="markline-btn cancle"  key="back" onClick={this.hideDialog}>
                  取消
                </Button>,
                <Button className="markline-btn submit" key="submit" type="primary" onClick={this.handleOk}>
                  确认
                </Button>,
              ]}
            >
              <div className="markline-config-wrapper" ref={(node) => { this.layerList = node }}>
                <div className="markline-config-button-wrapper">
                  <span>
                    <i onClick={this.addMarkline} className="iconfont icon-plus1"/>
                    配置条件
                  </span>
                </div>
                {this.renderMarklineConfigList()}
              </div>
            </Modal>
          </div>
        </div>
        {
          conditions.length > 0 && <div className="layout-config-column-custom markline-config">
            {
              this.renderMarklineList()
            }
          </div>
        }
      </div>
    )
  }

  toggleShowName(e) {
    this.setState({
      data: {
        ...this.state.data,
        show: e.target.checked
      }
    })
  }

  handleOk = () => {
    if (this.checkDataValid()) {
      this.setState({
        visible: false,
      }, () => {
        this.props.onChange({ ...this.state.data })
      })
    }
  }

  showErr(msg) {
    this.showTip({
      status: 'error center-position',
      content: msg,
    })
  }

  // 验证
  checkDataValid() {
    // 1、name 值不能为空
    // 2、固定值的情况下. value 不能为空
    const reg = /^(-|\+)?\d+(\.\d+)?$/
    let valid = true

    this.state.data.data.forEach((item) => {
      if (!item.name) {
        valid = false
        this.showErr('名称不能为空')
      } else if (item.mode === '固定值' && (!item.value || !reg.test(item.value))) {
        valid = false
        this.showErr('固定值类型辅助线必须填写一个数值')
      } else if (item.mode === '计算值' && item.formula_mode === 'percentile' && (!item.percentile || !reg.test(item.percentile))) {
        valid = false
        this.showErr('百分比类型辅助线必须填写一个数值')
      }
    })

    // 名字是否相同
    const names = this.state.data.data.map(data => data.name)
    const remdub = Array.from(new Set(names))

    if (remdub.length !== this.state.data.data.length) {
      valid = false
      return this.showErr('名称存在重复')
    }
    return valid
  }

  showDialog = () => {
    const state = {
      visible: true
    }
    this.setState(state, () => this.checkEmpty())
  }

  checkEmpty() {
    const { data } = this.state.data
    const selectData = this.getSelectData()
    const errorMsgs = []
    _.isArray(data) && data.forEach((item) => {
      if (item.mode !== '计算值') {
        return
      }
      const flag = selectData.find(num => num.num === item.num)
      if (!flag) {
        const msg = `“${item.name}”辅助线不生效, 因原有计算字段不存在, 请重新配置计算字段`
        errorMsgs.push(msg)
      }
    })
    // 延时队列弹出提醒，以避免过快弹出导致覆盖前一个提醒
    const _noticeError = () => {
      if (errorMsgs.length > 0) {
        const msg = errorMsgs.shift()
        notifyAlert('', msg, 'warning', 4.5)
        setTimeout(() => {
          _noticeError()
        }, 50)
      }
    }
    _noticeError()
  }

  hideDialog = () => {
    const { data } = this.props
    //如果取消则恢复原来的值
    this.setState({
      data,
      visible: false
    })
  }

  removeConfigs = () => {
    //清空所有配置
    Modal.confirm({
      title: '确定要删除辅助线配置？',
      content: '将删除已配置的辅助线,可以通过页面顶部撤销功能撤回删除操作,请知晓并确认操作风险',
      width: 500,
      className: 'variable-bind-delete-confirm-dialog',
      onOk: () => {
        this.setState({
          data: {
            ..._.cloneDeep(this.props.data),
            data: []
          }
        }, () => {
          this.props.onChange(this.state.data)
        })
      },
      onCancel() { },
    })
  }

  createDefaultName(no) {
    no = no || this.state.data.data.length + 1
    const name = `辅助线(${no})`
    const index = this.state.data.data.findIndex(item => item.name === name)
    if (index > -1) {
      return this.createDefaultName(no + 1)
    }
    return name
  }

  addMarkline = () => {
    const { data } = this.state.data
    const newItem = {
      name: this.createDefaultName() || '辅助线(1)',
      mode: '固定值',
      value: '',  // mode 为固定值生效
      num: '',    // mode 为计算值生效
      percentile: '', // 百分比
      formula_mode: '', // 计算方法
      config: { // 样式
        ...defaultSettings,
      }
    }
    data.push(newItem)
    this.setState({
      data: {
        ...this.state.data,
        data
      }
    })
  }

  SortableItem = SortableElement(({ item, order }) => this.renderConfigList(item, order))

  SortableList = SortableContainer(({ conditions }) => {
    const { SortableItem } = this

    return (
      <div className='markline-config-conditions-wrapper'>
        <div className="markline-config-conditions-items" ref={(node) => { this.conditionsWrapper = node }}>
          {
            conditions.map((item, index) => SortableItem && <SortableItem order={index} key={`${item.dataset_field_id}_${index}`} item={item} index={index}/>)
          }
        </div>
      </div>
    )
  })


  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ data }) => {
      const newConditions = arrayMove(data.data, oldIndex, newIndex)
      newConditions.forEach((c, index) => { c.order = index })
      return {
        data: {
          ...this.state.data,
          data: newConditions
        }
      }
    })
  }

  renderMarklineConfigList = () => {
    const { SortableList } = this

    const conditions = this.state.data.data

    if (conditions.length === 0) {
      return (
        <div className='markline-config-conditions-wrapper'>
          <div className="markline-config-empty">
            <div><span className="empty-icon"/></div>
            <div>暂时还未设置辅助线</div>
          </div>
        </div>
      )
    }
    if (!SortableList) return null

    return (
      <SortableList
        shouldCancelStart={shouldCancelStart}
        onSortEnd={this.onSortEnd}
        helperClass="table-cell-style-config-sort-item"
        conditions={conditions}/>
    )
  }

  getSelectData() {
    const { data } = this.state
    const { markline_axis } = data
    const { chart } = this.props
    const select_list = chart.nums || []
    const zaxis_list = chart.zaxis || []
    const chartCode = chart.chart_code
    let selectData = []
    if (markline_axis === 'y' || !markline_axis) {
      selectData = _.cloneDeep(select_list)
      if (chartCode === 'double_axis') {
        //双轴图
        selectData = select_list.slice(0, 1)
      }
    } else if (markline_axis === 'z') {
      //次轴辅助线
      if (zaxis_list.length > 0) {
        selectData = _.cloneDeep(zaxis_list)
      } else if (chartCode === 'double_axis') {
        //双轴图
        selectData = select_list.slice(1, 2)
      }
    }
    return selectData
  }

  renderConfigList = (item, index) => {
    const selectData = this.getSelectData()
    const modeList = ['固定值']
    selectData.length > 0 && modeList.push('计算值')

    return (
      <div
        key={`${item.dataset_field_id}_${index}`}
        className={`${cssStyles.marklineConfigItem} ${ITEM_CLASS}`}
      >
        <i className="draggable-icon"/>
        <div className="cell" style={{ marginLeft: 32, marginRight: 8, width: 98, flex: 0, flexShrink: 0 }}>
          <Input
            type="text"
            placeholder="名称"
            value={item.name}
            style={{ width: '98px' }}
            onChange={this.handleChange.bind(this, index, 'name')}
          />
        </div>
        <div className="cell" style={{ width: '88px', flex: 0, flexShrink: 0, flexBasis: '88px' }}>
          <Select
            getPopupContainer={() => this.conditionsWrapper || document.body}
            value={item.mode}
            style={{ height: 32 }}
            onChange={this.handleSelect.bind(this, index, 'mode')}
          >
            {modeList.map((mode, key) => <Select.Option key={key} value={mode}>{mode}</Select.Option>)}
          </Select>
        </div>
        {this.renderConditionsValue(item, index, selectData)}
        {this.renderStyleConfig(item, index)}
        <i onClick={this.removeConfig.bind(this, index)} className="condition-remove iconfont icon-recycle-bin"/>
      </div>
    )
  }

  renderMarklineList = () => {
    const { data } = this.state.data
    return (
      <div className="markline-config-conditions">
        <ul>
          {
            data.map((item, index) => {
              const { config, name, mode, value, formula_mode } = item
              const { style, width, color } = config || this.state.data
              const wrapperClassName = classnames({
                'config-icon-wrapper': true,
                'no-border': true
              })

              const lineStyle = {
                borderBottomColor: color,
                borderBottomWidth: width,
                borderBottomStyle: style
              }

              return (<li key={`markline-config-condition-${index}`} className="markline-config-condition">
                <span className="label-text">{name}</span>
                <span className="value-text" >{ mode === '固定值' ? value : getCalcName(formula_mode) }</span>
                <span className={wrapperClassName} style={{ float: 'right' }}>
                  <i className='line-preview' style={lineStyle}/>
                </span>
              </li>)
            })
          }
        </ul>
      </div>
    )
  }

  renderConditionsValue = (item, index, selectData) => {
    const { foucsSelectNums } = this.state
    const { mode } = item
    if (mode === '计算值') {
      const selectName = `_selector_num_${item.num}`
      const isPercentile = item.formula_mode === 'percentile'
      const notFound = !selectData.find(num => num.num === item.num)
      const isFoucsed = foucsSelectNums.includes(item.num)

      const notFoundIcon = (<i className="not-found-warning" style={{ color: '#faad14', position: 'relative', top: 5 }}>
        <svg viewBox="64 64 896 896" focusable="false"  data-icon="exclamation-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"></path></svg>
      </i>)

      const selectStyle = { borderRadius: 2, border: '1px solid transparent' }
      if (notFound && !isFoucsed) {
        selectStyle.border = '1px solid #FAAD14'
      }
      return (<React.Fragment>
        <div className="cell"  style={{ width: '120px', flex: 0, flexShrink: 0, flexBasis: '120px' }}>
          <Select
            ref={(e) => { this[selectName] = e }}
            getPopupContainer={() => this.conditionsWrapper || document.body}
            value={item.num}
            style={selectStyle}
            onChange={this.handleSelect.bind(this, index, 'num')}
            suffixIcon={(notFound && !isFoucsed) ? notFoundIcon : null}
            onFocus={() => {
              this.setState({ foucsSelectNums: [...foucsSelectNums, item.num] }, () => {
                // 点击icon时，antd出了bug，需要手动触发打开下拉
                const rcSelect = _.get(this, `${selectName}.selector.rcSelect`)
                if (rcSelect) {
                  if (this._numTimer) {
                    clearTimeout(this._numTimer)
                  }
                  this._numTimer = setTimeout(() => {
                    this._numTimer = null
                    if (!rcSelect.state.open) {
                      rcSelect.openIfHasChildren()
                    }
                  }, 200)
                }
              })
            }}
            onBlur={() => {
              this.setState({ foucsSelectNums: foucsSelectNums.filter(d => d !== item.num) })
              if (this._numTimer) {
                clearTimeout(this._numTimer)
              }
            }}
          >
            {selectData.map(num => <Select.Option value={num.num} key={`marklineNum_${num.num}`}>
              {num.formula_mode ? `${num.alias || num.alias_name || num.col_name}(${RESERVE_OPTION_MAPS[num.formula_mode]})` : `${num.alias || num.alias_name || num.col_name}`}
            </Select.Option>)}
          </Select>
        </div>
        <div className="cell"  style={{ width: isPercentile ? '88px' : '141px', flex: 0, flexShrink: 0, flexBasis: isPercentile ? '88px' : '141px' }}>
          <Select
            getPopupContainer={() => this.conditionsWrapper || document.body}
            value={item.formula_mode}
            style={{ height: 32 }}
            onChange={this.handleSelect.bind(this, index, 'formula_mode')}
          >
            {CalcList.map(calc => <Select.Option key={`calcList_${calc.value}`} value={calc.value}>{calc.text}</Select.Option>)}
          </Select>
        </div>
        {
          isPercentile && (<div className="cell" style={{ width: '45px', flex: 0, flexShrink: 0, flexBasis: '45px' }}>
            <Input type="number" min="0" max="100" value={item.percentile} onChange={this.handleChange.bind(this, index, 'percentile')}/>
          </div>)
        }
      </React.Fragment>)
    } else {
      // 固定值
      return (<div className="cell" style={{ width: '270px', flex: 0, flexShrink: 0, flexBasis: '270px' }}>
        <Input type="text" placeholder="请输入数值" value={item.value} onChange={this.handleChange.bind(this, index, 'value')} style={{ width: '270px' }} />
      </div>)
    }
  }

  generateIcon = (config = {}, options = {}) => {
    const { color, width, style } = config
    const { length } = options
    const wrapperClassName = classnames({
      'config-icon-wrapper': true,
      'no-border': true
    })
    const currentStyle = {
      borderBottomColor: color,
      borderBottomWidth: width,
      borderBottomStyle: style,
      width: `${length !== undefined ? length : 20}px`,
    }
    return (
      <span className={wrapperClassName} style={currentStyle}></span>
    )
  }

  renderStyleConfig = (item, index) => {
    const config = item.config || this.state.data

    const { visible } =  item
    const wrapStyle = { height: '303px' }
    const configMenu = (
      <div className="markline-dropdown-overlay" style={wrapStyle}>
        <div className="default-color-option" style={{ height: '125px' }}>
          <ul>
            {DEFAULT_LINE.map((i, _index) => {
              const isSelected = i.color === config.color && i.width === config.width && i.style === config.style
              return (
                <li onClick={this.handleChangeStyle.bind(this, index, i)} key={`render-style-config-${_index}`} className={`${isSelected ? 'selected' : ''}`}>
                  {this.generateIcon(i, { length: 60 })}
                </li>
              )
            })}
          </ul>
        </div>
        <div className="custom-color-option">
          <div className="custom-option-title">
            自定义样式
          </div>
          <div className="custom-option-config">
            <div className="custom-option-config-title"><span>颜色</span></div>
            <Popover
              content={
                <ColorPicker
                  color={config.color || 'transparent'}
                  changeAtOnce={false}
                  onSure={this.handleConfirmStyleChange.bind(this, index, 'color')}
                  onHide={this.handleHideColorPickerPopover}
                  disableAlpha={false}
                />
              }
              trigger="click"
              overlayStyle={{ zIndex: 1060 }}
              placement="bottomLeft"
              className="table-cell-config-color-picker-popover-container"
            >
              <div style={{ float: 'left' }}>
                <span className={`custom-option-round ${!config.color ? 'no-color' : ''}`} style={{ background: config.color || 'transparent' }}/>
              </div>
            </Popover>
          </div>
          <div className="custom-option-config">
            <div className="custom-option-config-title"><span>样式</span></div>
            <div style={{ float: 'left' }}>
              <Select
                getPopupContainer={() => document.body}
                maxHeight={104}
                dropdownClassName="markline-value-select-dropdown"
                value={config.style}
                style={{ width: 88, height: 28 }}
                onChange={this.handleConfirmStyleChange.bind(this, index, 'style')}
              >
                {LineStyles.map(line => <Select.Option value={line.value} key={line.value}>
                  {this.generateIcon(line.style, { length: 72 })}
                </Select.Option>)}
              </Select>
            </div>
          </div>
          <div className="custom-option-config">
            <div className="custom-option-config-title"><span>粗细</span></div>
            <div style={{ float: 'left' }}>
              <NumberInput className="border-input"
                style={{ width: '88px', height: 28 }}
                changeOnBlur={true}
                debounce={true}
                value={config.width}
                onChange={this.handleConfirmStyleChange.bind(this, index, 'width')}
              />
            </div>
          </div>
        </div>
      </div>
    )
    return (
      <div className="cell" style={{ width: 50, flex: 0, flexShrink: 0 }}>
        <Dropdown
          trigger={['click']}
          overlay={configMenu}
          placement='bottomLeft'
          visible={visible}
          onVisibleChange={this.handleChangeVisible.bind(this, index)}
        >
          <div className="config-style-wrapper">
            {
              this.generateIcon(config)
            }
          </div>
        </Dropdown>
      </div>
    )
  }

  removeConfig = (index) => {
    const { data } = this.state.data
    data.splice(index, 1)
    this.setState({
      data: {
        ...this.state.data,
        data: [...data]
      }
    })
  }

  closeDropdown = () => {
    const conditions = this.state.data.data
    if (conditions.length <= 0 || conditions.every(d => !d.visible)) return

    conditions.forEach((c) => { c.visible = false })
    this.enableHidden = false
    this.handleHideColorPickerPopover()
    this.setState({
      data: {
        ..._.cloneDeep(this.props.data),
        data: conditions
      }
    })
  }

  handleSelect(rowIndex, _axis, value) {
    const { calc_num } = this.state
    const { data, markline_axis } = this.state.data
    const { chart } = this.props
    const select_list = chart.nums || []
    const zaxis_list = chart.zaxis || []
    const chartCode = chart.chart_code

    if (data[rowIndex]) {
      data[rowIndex][_axis] = value
    }
    // 如果 _axis 为 mode, 且为计算值的时候，应该默认 calc 为 第一项. 同时设置 num 为默认的第一项
    if (_axis === 'mode' && value === '计算值') {
      let selectData = []
      if (markline_axis === 'y' || !markline_axis) {
        selectData = _.cloneDeep(select_list)
        if (chartCode === 'double_axis') {
          //双轴图
          selectData = select_list.slice(0, 1)
        }
      } else if (markline_axis === 'z') {
        //次轴辅助线
        if (zaxis_list.length > 0) {
          selectData = _.cloneDeep(zaxis_list)
        } else if (chartCode === 'double_axis') {
          //双轴图
          selectData = select_list.slice(1, 2)
        }
      }
      if (data[rowIndex]) {
        data[rowIndex].num = selectData[0].num
        data[rowIndex].formula_mode = CalcList[0].value
      }
    } else if (_axis === 'mode' && value === '高级计算') {
      data[rowIndex].num = calc_num[0] ? calc_num[0].value : ''
      data[rowIndex].formula_mode = CalcList[0].value
    }
    this.setState({ data: { ...this.state.data, data } })
  }

  handleChange(rowIndex, key, e) {
    const { data } = this.state.data
    const { value } = e.target
    if (data[rowIndex]) {
      data[rowIndex][key] = value
    }

    if (key === 'percentile' && (value < 0 || value > 100)) {
      return
    }

    this.setState({
      data: { ...this.state.data, data: [...data] }
    })
  }

  handleChangeVisible = (index, status) => {
    const conditions = this.state.data.data
    if (status) {
      conditions[index].visible = status
      this.setState({
        data: {
          ..._.cloneDeep(this.props.data),
          data: [...conditions]
        }
      })
    }
  }

  clickBody = (e) => {
    const conditions = this.state.data.data
    const parent = $(e.target).parents('.table-cell-config-color-picker-popover-container')
    const isDropdownParent = $(e.target).parents('.markline-dropdown-overlay').length > 0 || $(e.target).hasClass('markline-dropdown-overlay')
    const isDropdownTrigger = $(e.target).hasClass('ant-dropdown-trigger') || $(e.target).parents('.ant-dropdown-trigger').length > 0
    const isColorSelect = $(e.target).closest('.markline-color-select-dropdown').length > 0 || $(e.target).closest('.markline-value-select-dropdown').length > 0

    if (($(parent).length === 0 && !isDropdownParent && !isDropdownTrigger && !isColorSelect) || (isDropdownTrigger && this.enableHidden)) {
      this.enableHidden = false
      if (_.find(conditions, c => c.visible === true)) {
        conditions.forEach((c) => { c.visible = false })
        this.setState({
          data: {
            ..._.cloneDeep(this.props.data),
            data: [...conditions]
          }
        })
      }
    } else if (isDropdownTrigger && !this.enableHidden) {
      this.enableHidden = true
    }
  }

  handleConfirmStyleChange = (index, type, value) => {
    const { data } = this.state.data
    const newStyles = { ...data[index].config }
    value = typeof value === 'object' ? value.value : value

    if (type === 'width' && (value < 0 || value > 100)) {
      return
    }

    if (newStyles[type] !== undefined) {
      newStyles[type] = value
    }

    data[index] = {
      ...data[index],
      config: newStyles
    }
    this.setState({
      data: {
        ..._.cloneDeep(this.props.data),
        data: [...data]
      }
    })
  }

  handleHideColorPickerPopover = () => {
    // 触发关闭popover
    const overlay = $('.markline-dropdown-overlay')[0]
    overlay && overlay.dispatchEvent(new CustomEvent('mousedown', { bubbles: true }))
  }

  handleChangeStyle = (index, item, e) => {
    const { data } = this.state.data
    e.preventDefault()
    const newStyles = { ...data[index].config, ...item }
    data[index] = {
      ...data[index],
      config: newStyles
    }
    this.setState({
      data: {
        ..._.cloneDeep(this.props.data),
        data: [...data]
      }
    })
  }

}

reactMixin.onClass(MarklineConfig, TipMixin)
export default MarklineConfig
